export const analyticsMapping = {
  '3883d336d323cea7': 'https://analytics.google.com/analytics/web/#/dashboard/nO0AOoPySCuCyDUvWYIzxg/a136823689w200469195p205595536',
  'bb41e921579aa1e9': 'https://analytics.google.com/analytics/web/#/dashboard/pj0HkSv7RD-Q2uOOKp33Ug/a136823689w200469195p225168560/',
  '46330154985204ab': 'https://analytics.google.com/analytics/web/?authuser=4#/dashboard/YTweDvhrTNe22I30tB5uuA/a136823689w200469195p226625627/',
  '2001db1539689c6d': 'https://analytics.google.com/analytics/web/#/dashboard/nO0AOoPySCuCyDUvWYIzxg/a136823689w200469195p205595536/',
  '16efe5dccd746617': 'https://analytics.google.com/analytics/web/?authuser=4#/report-home/a136823689w200469195p204057151',
}
